import { api } from "@/lib/orgApi";

export const RXNORM_SYSTEM = "http://www.nlm.nih.gov/research/umls/rxnorm";

export async function listMedications({ q, active, category } = {}) {
  const params = {};
  if (q) params.q = q;
  if (active != null) params.active = active;
  if (category) params.category = category;
  const { data } = await api.get("/medications", { params });
  return data;
}

export async function getMedication(medicationId) {
  const { data } = await api.get(`/medications/${encodeURIComponent(medicationId)}`);
  return data;
}
